module.exports = __webpack_public_path__ + "img/loghi_0004_granter.9b820e94.png";